module.exports = __webpack_public_path__ + "static/media/4.18.a875853c.png";